import { RegistrerUserDto } from "@green0meter/api-client";
import { type ActionFunction, json } from "react-router-dom";

import { usersApi } from "@api/services";

// TODO: issue #4023 caused by using login hook in RegisterForm.action - TODO: add proper hook for registration

export const registerAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const email = formData.get("email");
  const password = formData.get("password");
  const firstName = formData.get("firstName");
  const lastName = formData.get("lastName");
  const phone = formData.get("phone");
  const companyName = formData.get("companyName");
  const registrationCountry = formData.get("registrationCountry");
  const companyId = formData.get("companyId");

  if (
    !email ||
    !password ||
    !firstName ||
    !lastName ||
    !companyName ||
    !companyId ||
    !registrationCountry
  ) {
    return null;
  }

  // Keep in mind to update version when the terms and conditions change
  const termsAndConditionsVersion = 1;

  const dto: RegistrerUserDto & {
    termsAndConditionsVersion: number;
  } = {
    email: email.toString(),
    password: password.toString(),
    firstName: firstName.toString(),
    lastName: lastName.toString(),
    phoneNumber: phone?.toString(),
    companyName: companyName.toString(),
    country: registrationCountry.toString(),
    companyId: companyId.toString(),
    termsAndConditionsVersion,
  };

  try {
    await usersApi.usersControllerRegisterUser(dto);
  } catch (e: unknown) {
    if (e instanceof Error && "response" in e) {
      const errorResponse = (
        e as { response: { status: number; data: { message: string } } }
      ).response;

      return json(
        { statusCode: errorResponse.status, message: errorResponse.data.message },
        { status: errorResponse.status },
      );
    }
    throw e;
  }

  return json(
    {
      loginAfterRegistration: {
        username: dto.email,
        password: dto.password,
      },
    },
    { status: 200 },
  );
};
